import { render, staticRenderFns } from "./PerfilAcessoList.vue?vue&type=template&id=1a3cf756&scoped=true&"
import script from "./PerfilAcessoList.vue?vue&type=script&lang=js&"
export * from "./PerfilAcessoList.vue?vue&type=script&lang=js&"
import style0 from "./PerfilAcessoList.vue?vue&type=style&index=0&id=1a3cf756&prod&lang=scss&scoped=true&"
import style1 from "./PerfilAcessoList.vue?vue&type=style&index=1&id=1a3cf756&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3cf756",
  null
  
)

export default component.exports